<template>
  <b-card >
    <h3 class="mb-2 font-weight-bold">
      Total por Arranjo
    </h3>
    <b-table 
    :items="items"
     :fields="fields" 
     responsive 
     small 
     striped 
     hover  
    :per-page="perPage"
    :current-page="page"
    :busy="isLoading"
    show-empty
     class="text-center">
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle" />
        </div>
      </template>
      <template #empty>
        <div class="text-center py-3">
          <p v-if="noDataMessage" class="text-danger font-weight-bold" style="font-size: 1rem;">
            {{ noDataMessage }}
          </p>
          <p v-else class="text-muted">
            Sem registros para exibir.
          </p>
        </div>
      </template>
    </b-table>
    <b-pagination
      v-if="!isLoading"
      v-model="page"
      :per-page="perPage"
      :total-rows="totalRows"
      align="center"
      size="sm"
      class="mt-2"
    />
  </b-card>
</template>
 
<script>
import { BCard, BTable, BPagination, BSpinner } from "bootstrap-vue";
import { formatValue } from "@/utils";

export default {
  name: "TotalArrangementTable",
  components: { BCard, BTable, BPagination, BSpinner },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    noDataMessage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      fields: [
        { key: "arrangement", label: "Arranjo" },
        { key: "brand", label: "Bandeira" },
        { key: "type", label: "Tipo" },
        { key: "settledCount", label: "Qtd Liquidado" },
        { key: "settledAmount", label: "Valor Liquidado (R$)", formatter: "formatValue" },
        { key: "pendingOrErrorCount", label: "Qtd Pendente/Erro",  tdClass: "text-danger font-weight-bold" },
        { key: "pendingOrErrorAmount", label: "Valor Pendente/Erro (R$)", formatter: "formatValue" },
        { key: "totalAmount", label: "Total Geral (R$)", formatter: "formatValue" },
      ],
    };
  },
  computed: {
    totalRows() {
      return this.items.length;
    },
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined) return "-";
      return formatValue(value);
    },

    formatCell(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return value;
    },
  }
};
</script>
